import { buttonTheme } from "./button";
import { badgeTheme } from "./badge";
import { avatarTheme } from "./avatar";
import { tagTheme } from "./tag";
import { linkTheme } from "./link";
/**
 * Custom Verdant themes, there is no differences in this components in mx or cgx
 */
export var components = {
    Button: buttonTheme,
    Badge: badgeTheme,
    Avatar: avatarTheme,
    Tag: tagTheme,
    Link: linkTheme,
};
